import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { TranslocoService } from "@ngneat/transloco";
import { Violation } from "src/app/interfaces/Violation.interface";
import { TrsEventsService } from "src/app/services/trsevents.service";
import { copyToClipBoard } from "src/app/utils/generic";
import { getConvertedDateTime } from "src/app/utils/timeManager";

@Component({
    selector: 'screen-glance-details-popup',
    templateUrl: './screen-glance-details-popup.html',
    styleUrls: ['./screen-glance-details-popup.sass'],
})
export class ScreenGlanceDetailsPopupComponent implements OnInit {
    @Input() eventDetails: Violation;

    closeLabel: string = "";
    eventLabel: string = "";
    sessionIdLabel: string = "";
    initiatorLabel: string = "";
    timestampLabel: string = "";
    reasonLabel: string = "";
    copyToClipBoard: string = "";
    copiedText: string = "";

    showCopiedTooltip: boolean = false

    constructor(private translationService: TranslocoService, private trsEventService: TrsEventsService) {
        this.updateComponentLabels();
    }

    @Output() ClosePopUpEvent: EventEmitter<any> = new EventEmitter();

    ngOnInit(): void {
        this.updateComponentLabels();
    }

    updateComponentLabels = (): void => {
        this.closeLabel = this.translationService.translate("Close");
        this.eventLabel = this.translationService.translate("Event");
        this.sessionIdLabel = this.translationService.translate("Session ID");
        this.initiatorLabel = this.translationService.translate("Initiator");
        this.timestampLabel = this.translationService.translate("Timestamp");
        this.reasonLabel = this.translationService.translate("Reason");
        this.copyToClipBoard = this.translationService.translate("Copy to Clipboard");
        this.copiedText = this.translationService.translate("Copied");
    }

    closePopup = (): void => {
        this.ClosePopUpEvent.emit("Close");
    }

    formatDateTime = (dateTime: string | Date | null): Date => {
        if (dateTime == null)
            return new Date();
        else return getConvertedDateTime(dateTime);
    }

    copyText = async (sessionId: string) => {
        const copyStatus: boolean = await copyToClipBoard(sessionId);
        if (copyStatus === true) {
            this.showCopiedTooltip = true;
            setTimeout(() => this.showCopiedTooltip = false, 1200)
        }
    }
}